import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Components
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PopupForm } from "./components/PopupForm";

// Pages
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { LandingPage } from "./pages/LandingPage";

// Service Pages
import { TrademarkRegistration } from "./pages/services/TrademarkRegistration";
import { CopyrightRegistration } from "./pages/services/CopyrightRegistration";
import { TrademarkSearch } from "./pages/services/TrademarkSearch";
import { CompanyFormation } from "./pages/services/CompanyFormation";
import { AmazonBrandRegistry } from "./pages/services/AmazonBrandRegistry";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header onOpenPopup={handleOpenPopup} />
        <Routes>
          <Route path="/" element={<Home onOpenPopup={handleOpenPopup} />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/trademark-registration" element={<TrademarkRegistration onOpenPopup={handleOpenPopup} />} />
          <Route path="/services/copyright-registration" element={<CopyrightRegistration onOpenPopup={handleOpenPopup} />} />
          <Route path="/services/trademark-search" element={<TrademarkSearch onOpenPopup={handleOpenPopup} />} />
          <Route path="/services/company-formation" element={<CompanyFormation onOpenPopup={handleOpenPopup} />} />
          <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry onOpenPopup={handleOpenPopup} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/lp" element={<LandingPage />} />
        </Routes>
        <Footer />
        <PopupForm isOpen={isPopupOpen} onClose={handleClosePopup} />
      </BrowserRouter>
    </div>
  );
}

export default App;
